import { render } from "./HasInAppPurchasePropsCmp.vue?vue&type=template&id=472ba1d8"
import script from "./HasInAppPurchasePropsCmp.vue?vue&type=script&lang=js"
export * from "./HasInAppPurchasePropsCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__